<template>
  <div class="card border-secondary text-dark bg-light ml-2 mr-2 card-arredondado flex-grow-1">
    <div class="card-body">
      <slot name="subtitulo">
        <h6 class="card-subtitle text-muted">Plano</h6>
      </slot>
      <slot name="titulo">
        <h1 class="card-text"> {{plano.nome}}</h1>
      </slot>
      <slot name="descricao">
        <p class="card-text text-left mt-4">{{plano.descricao}}</p>
      </slot>
      <slot name="valor">
        <h2 class="pricing-card-title text-center">
        {{ plano.valor > 0 ? formatarValorMonetario(plano.valor) : 'Gratuito' }}
        </h2>
        <p v-if="plano.valor > 0" class="text-muted text-center small">por mês</p>
        <p v-else><br> </p>
      </slot>
      <slot name="acoes">
      </slot>
    </div>

    <slot name="rodape">
      <div class="card-footer card-rodape">
        <ul class="list-group list-group-flush text-left">
          <li class="list-group-item produtos-plano-light" v-for="item of plano.item_planos" :key="item.id">
            <i class="fa fa-check small" aria-hidden="true"></i>
            <span class="ml-1" v-if="item.quantidade && !item.ilimitado">
              {{item.quantidade}} {{item.nome}}
            </span>
            <span class="ml-1" v-else-if="item.ilimitado">
              {{item.nome}} <span class="text-bold">ilimitados</span>
            </span>
          </li>
        </ul>
      </div>
    </slot>
  </div>
</template>
<script>
import util from '@/util'
export default {
  name: 'plano',
  props: {
    plano: {
      type: Object
    }
  },
  methods: {
    formatarValorMonetario (valor) {
      return util.formatarValorMonetarioComCifrao(valor)
    }
  }
}
</script>

<style scoped>
@import "./scss/plano.scss";
</style>
